import { twMerge } from 'tailwind-merge';

export interface LinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

export const Link = ({ href, children, className }: LinkProps) => {
  if (!href) return <span className={className}>{children}</span>;

  // If href doesn't start with http: or https:, prepend https://
  let processedHref = href;
  if (href && typeof href === 'string' && !href.startsWith('http:') && !href.startsWith('https:')) {
    processedHref = `https://${href}`;
  }

  return (
    <a
      href={processedHref}
      target="_blank"
      rel="noopener noreferrer"
      className={twMerge('text-base text-blue-500 font-normal', className)}
    >
      {children}
    </a>
  );
};
